import { stopSubmit } from 'redux-form';
import { all, call, put, takeLatest } from 'redux-saga/effects';

import * as errorHandlerActions from '@/components/errorHandler/Actions';
import { ROUTES_API } from '@/services/Constants';
import { processRequest } from '@/services/Api';
import { isSimpleEmail } from '@/services/FormValidate';
import { historyReplace } from '@/services/History';
import * as signInActions from '../store/actions';
import { SIGN_IN_FORM, signInActionTypes } from '../store/constants';

export default function* (): Generator {
	yield all([yield takeLatest(signInActionTypes.LOGIN_REQUEST, handleLoginRequest)]);
}

export function* handleLoginRequest(action: any) {
	try {
		const { email_or_username, password, path } = action.payload;

		const requestBody: Record<string, string> = { password };
		if (isSimpleEmail(email_or_username)) {
			requestBody.email = email_or_username;
		} else {
			requestBody.username = email_or_username;
		}
		const { data } = yield call(processRequest, ROUTES_API.GET_TOKEN, 'POST', requestBody);
		yield put(signInActions.loginSuccess(data.auth_token));

		yield call(historyReplace, path);
	} catch (e: any) {
		yield put(stopSubmit(SIGN_IN_FORM, { password: e.response.data.info }));
		yield put(errorHandlerActions.handleError(e, 'notification'));
		yield put(signInActions.loginError());
	}
}
